import React, { useState } from 'react';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import { useModal } from 'hooks';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import { LabelsRow } from '../../components/LabelRows';
import { FreightItemRow } from '../../components/FreightItemRow';
import ExtraFields from '../../components/ExtraFields';
import { SummaryRow } from '../../components/SummaryRow';
import { ExtraFieldButton } from '../../components/ExtraFieldButton';
import ObservationInput from '../../components/ObservationInput';
import ExtraFieldsModal from '../../components/ExtraFieldModal';

export default function ShipmentTransferEdit({
  isAttended,
  defaultIsOpen = false,
  extraFieldButton = true,
}) {
  const {
    totalShipmentTransfer,
    shipmentTransferExtraFields,
    shouldUseTransferToll,
    shouldUseTransferDischarge,
    shouldUseTransferCharge,
    shouldUseTransferFerry,
    transferTollValue,
    transferDischargeValue,
    transferChargeValue,
    transferFerryValue,
    isBRLCurrency,
    erpExchangeValue,
    setShipmentTransferExtraFields,
    onChangePcpObservation,
    pcpObservation,
    transferTags,
    errors,
    onChangeNegotiatorObservation,
    negotiatorObservation,
  } = useFreightValues();
  const extraFieldsModal = useModal();
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  function onToggleCard() {
    setIsOpen(!isOpen);
  }

  function onRemoveField(index) {
    setShipmentTransferExtraFields((old) => old.filter((_, idx) => idx !== index));
  }

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Repasse ao Transportador"
        tooltipContent="Valores a serem repassados ao transportador conforme itens definidos, não contempla taxa administrativa sobre o valor."
        isOpen={isOpen}
        onToggleCard={onToggleCard}
        totalsSection={
          <HeaderTotalSummary
            label="Crédito Transportador"
            totalInReal={totalShipmentTransfer?.total}
            totalInDollar={totalShipmentTransfer?.totalDollarValue}
          />
        }
        hasTagsRow
        tagsContent={transferTags}
      />
      {isOpen && (
        <>
          <LabelsRow />
          {shouldUseTransferToll && (
            <FreightItemRow
              isBRLCurrency={isBRLCurrency}
              label="Pedágio"
              value={transferTollValue?.value}
              dollarValue={transferTollValue?.dollarValue}
              shouldDisableField
              id="credito-pedagio"
            />
          )}
          {shouldUseTransferDischarge && (
            <FreightItemRow
              isBRLCurrency={isBRLCurrency}
              label="Descarga"
              value={transferDischargeValue?.value}
              dollarValue={transferDischargeValue?.dollarValue}
              shouldDisableField
              id="credito-descarga"
            />
          )}
          {shouldUseTransferCharge && (
            <FreightItemRow
              isBRLCurrency={isBRLCurrency}
              label="Taxa de carregamento"
              value={transferChargeValue?.value}
              dollarValue={transferChargeValue?.dollarValue}
              shouldDisableField
              id="credito-taxa-carregamento"
            />
          )}
          {shouldUseTransferFerry && (
            <FreightItemRow
              isBRLCurrency={isBRLCurrency}
              label="Balsa"
              value={transferFerryValue?.value}
              dollarValue={transferFerryValue?.dollarValue}
              shouldDisableField
              id="credito-balsa"
            />
          )}
          {shipmentTransferExtraFields?.length > 0 ? (
            <>
              <Text type="regular" weight={500}>
                Valores extras
              </Text>
              <ExtraFields fields={shipmentTransferExtraFields} onRemoveField={onRemoveField} />
            </>
          ) : null}
          <SummaryRow
            label="Valor Crédito"
            totalInReal={totalShipmentTransfer?.total}
            totalInDollar={totalShipmentTransfer?.totalDollarValue}
            id="valor-crédito"
          />
          {extraFieldButton && (
            <ExtraFieldButton
              id="button-abrir-valores-extras-valor-credito"
              openModal={() => extraFieldsModal.open()}
            />
          )}
          <ExtraFieldsModal
            extraFields={shipmentTransferExtraFields}
            isOpen={extraFieldsModal.isOpen}
            handleClose={extraFieldsModal.close}
            onSave={(fields) => setShipmentTransferExtraFields(fields)}
            isBRLCurrency={isBRLCurrency}
            dollarToUse={erpExchangeValue}
          />
          <ObservationInput
            label="Observações PCP"
            value={pcpObservation}
            onChange={(event) => onChangePcpObservation(event.target.value)}
            error={errors?.pcpObservation}
            disabled={isAttended}
            id="observacoes"
          />
          {isAttended && (
            <ObservationInput
              label="Observações Negociador"
              value={negotiatorObservation}
              onChange={(event) => onChangeNegotiatorObservation(event.target.value)}
              id="observacoes"
            />
          )}
        </>
      )}
    </Card>
  );
}
